import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Button, FormControl, Table } from 'react-bootstrap';
import { FaList, FaPhoneAlt, FaHandshake, FaSearch } from 'react-icons/fa';
import Select from 'react-select';

import ApiUiController from '../../controller/ApiUiController';
import CallPopup from '../../components/call/CallPopup';
import MeetingPopup from '../../components/meeting/MeetingPopup';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import MainSearchAPI from '../../api/MainSearchAPI';
import Display from '../../util/Display';
import LeadConst from '../../util/LeadConst';
import withRouter from '../../util/WithRouter';

class SearchTable extends React.Component {

  static Phone = 'phone';

  constructor() {
    super();
    this.models = reactLocalStorage.getObject(Const.Model);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);

    this.Selections = [
      { label: 'Phone', value: SearchTable.Phone },
      { label: 'Name', value: 'name' },
      { label: 'Email', value: 'email' },
    ]

    this.LeadSearchRestrictView = Util.isAllow(this.models.lead_search.permission, Const.PermLeadSearchRestrictedView);
    this.LeadSearchRestrictAddCall = Util.isAllow(this.models.lead_search.permission, Const.PermLeadSearchAddCall);
    this.LeadSearchRestrictAddMeet = Util.isAllow(this.models.lead_search.permission, Const.PermLeadSearchAddMeet);
    
    this.LeadView = Util.isAllow(this.models.lead.permission, Const.PermView);
    this.LeadRestrict = Util.isAllow(this.models.lead.permission, Const.PermRestricAcc);

    /*
    this.ContactView = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactRestrict = Util.isAllow(this.models.contact.permission, Const.PermRestricAcc);

    this.PropertyView = Util.isAllow(this.models.property.permission, Const.PermView);
    this.PropertyRestrict = Util.isAllow(this.models.property.permission, Const.PermRestricAcc);

    this.ProjectView = Util.isAllow(this.models.project.permission, Const.PermView);
    this.ProjectRestrict = Util.isAllow(this.models.project.permission, Const.PermRestricAcc);
    */

    this.Restrictions = [user.user_id, ...user.child];

    this.SearchBody = {};
    this.length = 0;
    if(this.LeadView) {
      this.length = this.length + 1;
      this.SearchBody.lead = [];
    }
    /*
    if(this.ContactView) {
      this.length = this.length + 1;
      this.SearchBody.contact = [];
    }
    if(this.PropertyView) {
      this.length = this.length + 1;
      this.SearchBody.property = [];
    }
    if(this.ProjectView) {
      this.length = this.length + 1;
      this.SearchBody.project = [];
    }
    */

    this.state = { search: '', inSearch: false, popup: null, model_no: 0, model_id: 0,
      searches: { leads: []/*, contacts: [], properties: [], projects: []*/ },
      selection: this.Selections[0]
    };
  }

  onValueChange = () => {
    let inSearch = true;
    if(this.state.selection.value === SearchTable.Phone
      && this.state.search.length === 10) {
      MainSearchAPI.search({ key: SearchTable.Phone, search: this.state.search }, this.onReceived);
    } else if(this.state.selection.value !== SearchTable.Phone
      && this.state.search.length > 2) {
      MainSearchAPI.search({ key: this.state.selection.value, search: this.state.search }, this.onReceived);
    } else {
      inSearch = false;
    }
    this.setState({ ...this.state, inSearch,
      searches: { ...this.state.searches, leads: []/*, contacts: [], properties: [], projects: []*/ } });
  }

  onReceived = searches => this.setState({ ...this.state, inSearch: false, 
    searches: { ...this.state.searches, ...searches } });

  checkRestrictView = model => {
    if(this.LeadSearchRestrictView) {
      return true;
    }
    return model.responsible_person 
      && this.Restrictions.find(user => model.responsible_person.includes(Const.Opt + user + Const.Opt));
  }

  checkRestrictCall = model => {
    if(this.LeadSearchRestrictAddCall) {
      return true;
    }
    return model.responsible_person 
      && this.Restrictions.find(user => model.responsible_person.includes(Const.Opt + user + Const.Opt));
  }

  checkRestrictMeet = model => {
    if(this.LeadSearchRestrictAddMeet) {
      return true;
    }
    return model.responsible_person 
      && this.Restrictions.find(user => model.responsible_person.includes(Const.Opt + user + Const.Opt));
  }

  onPreview = (model_no, model) => {
    if(this.models.lead.model_no === model_no) {
      if(this.LeadRestrict) {
        if(!this.checkRestrictView(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
      this.props.navigate(`/lead/preview/${model.id}`);
    }/* else if(this.models.contact.model_no === model_no) {
      if(this.ContactRestrict) {
        if(!this.checkRestrictView(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
      this.props.navigate(`/contact/preview/${model.id}`);
    } else if(this.models.property.model_no === model_no) {
      if(this.PropertyRestrict) {
        if(!this.checkRestrictView(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
      this.props.navigate(`/property/preview/${model.id}`);
    } else if(this.models.project.model_no === model_no) {
      if(this.ProjectRestrict) {
        if(!this.checkRestrictView(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
      this.props.navigate(`/project/preview/${model.id}`);
    }*/
  }

  onCall = (model_no, model) => {
    if(this.models.lead.model_no === model_no) {
      if(this.LeadRestrict) {
        if(!this.checkRestrictCall(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
    }/* else if(this.models.contact.model_no === model_no) {
      if(this.ContactRestrict) {
        if(!this.checkRestrictCall(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
    }*/
    this.setState({ ...this.state, popup: LeadConst.Call, model_no: model_no, model_id: model.id  });
  }

  onMeet = (model_no, model) => {
    if(this.models.lead.model_no === model_no) {
      if(this.LeadRestrict) {
        if(!this.checkRestrictMeet(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
    }/* else if(this.models.contact.model_no === model_no) {
      if(this.ContactRestrict) {
        if(!this.checkRestrictMeet(model)) {
          Util.showError('You do not have access, Please contact to admin');
          return;
        }
      }
    }*/
    this.setState({ ...this.state, popup: LeadConst.Meeting, model_no: model_no, model_id: model.id  });
  }
  
  render() {
    return ( 
      <div className="container form-cont">
        <CallPopup show={this.state.popup === LeadConst.Call} onHide={() => this.setState({ ...this.state, popup: ''})}
          model_no={this.state.model_no} model_id={this.state.model_id} />
        <MeetingPopup show={this.state.popup === LeadConst.Meeting} onHide={() => this.setState({ ...this.state, popup:''})}
          model_no={this.state.model_no} model_id={this.state.model_id} />

        <div className="row row-cols-4" style={{ marginTop: 10}}>
          <div className="col">
            <FormControl type="text" className="mr-sm-2" placeholder="Search Leads" value={this.state.search}
              onChange={(event) => this.setState({ ...this.state, search: event.target.value })}
              onKeyDown={(event) => event.key === 'Enter' ? this.onValueChange() : null }
              />
          </div>
          <div className="col">
            <Select options={this.Selections} value={this.state.selection}
              onChange={selection => this.setState({ ...this.state, selection })} />
          </div>
          <div className="col">
            <span className="buttons" variant="primary" onClick={() => this.onValueChange()}>
              <FaSearch /> Search
            </span>
          </div>
        </div>

        <div className={`row row-cols-${this.length - 3}`}>
          
          { this.LeadView ?
            <div className="col">
              <div className="form-group">
                <h4>{this.models.lead.model_name}</h4>
                <Table striped bordered hover className="table-cursor">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>{this.models.lead.fields.responsible_person.label_name}</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.state.inSearch}>
                      {
                        this.state.searches.leads.length > 0
                        ? this.state.searches.leads.map(lead =>
                          <tr key={`lead_${lead.id}`}>
                            <td>{Display.ModelName(lead)}</td>
                            <td>{Display.FieldValue(lead, 'responsible_person', this.models.lead.fields)}</td>
                            <td>
                              <Button variant = "primary" size="sm" className = "m-1" onClick={() => this.onPreview(this.models.lead.model_no, lead)}> <FaList className="actionbtnp" color= "white" /> List </Button>
                              <Button  variant = "secondary" size="sm" className = "m-1" onClick={() => this.onCall(this.models.lead.model_no, lead)}><FaPhoneAlt className="actionbtnp"  color= "white"/> Call </Button> 
                              <Button variant = "warning" size="sm" className = "m-1" onClick={() => this.onMeet(this.models.lead.model_no,lead) }><FaHandshake className="actionbtnp" color= "white"/> Site Visit  </Button> 
                            </td>
                          </tr>
                        )
                        : <tr><td colSpan="3">No result found</td></tr>
                      }
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
            : null
          }

          { false && this.ContactView ?
            <div className="col">
              <div className="form-group">
                <h4>{this.models.contact.model_name}</h4>
                <Table striped bordered hover className="table-cursor">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.state.inSearch}>
                      {
                        this.state.searches.contacts.length > 0
                        ? this.state.searches.contacts.map(contact =>
                          <tr key={`contact_${contact.id}`}>
                            <td>{Display.ModelName(contact)}</td>
                            <td>
                              <FaList className="actionbtnp" onClick={() => this.onPreview(this.models.contact.model_no, contact)} />
                              <FaPhoneAlt className="actionbtnp" onClick={() => this.onCall(this.models.contact.model_no, contact)} />
                              <FaHandshake className="actionbtnp" onClick={() => this.onMeet(this.models.contact.model_no, contact)} />
                            </td>
                          </tr>
                        )
                        : <tr><td colSpan="2">No result found</td></tr>
                      }
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
            : null
          }

          { false && this.PropertyView ?
            <div className="col">
              <div className="form-group">
                <h4>{this.models.property.model_name}</h4>
                <Table striped bordered hover className="table-cursor">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.state.inSearch}>
                      {
                        this.state.searches.properties.length > 0
                        ? this.state.searches.properties.map(property =>
                          <tr key={`contact_${property.id}`}>
                            <td>{`${property.id} - ${property.name}`}</td>
                            <td>
                              <FaList className="actionbtnp" onClick={() => this.onPreview(this.models.property.model_no, property)} />
                            </td>
                          </tr>
                        )
                        : <tr><td colSpan="2">No result found</td></tr>
                      }
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
            : null
          }

          { false && this.ProjectView ?
            <div className="col">
              <div className="form-group">
                <h4>{this.models.project.model_name}</h4>
                <Table striped bordered hover className="table-cursor">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.state.inSearch}>
                      {
                        this.state.searches.projects.length > 0
                        ? this.state.searches.projects.map(project =>
                          <tr key={`contact_${project.id}`}>
                            <td>{`${project.id} - ${project.project_name}`}</td>
                            <td>
                              <FaList className="actionbtnp" onClick={() => this.onPreview(this.models.project.model_no, project)} />
                            </td>
                          </tr>
                        )
                        : <tr><td colSpan="2">No result found</td></tr>
                      }
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
            : null
          }
        </div>
      </div>
    );
  }
}
export default withRouter(SearchTable);